import routerOptions0 from "/home/shipu/workspace/Vue/stationaries/stationary-pub-hub/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}